"use strict";
exports.__esModule = true;
exports.LANGUAGE_KEY = void 0;
exports.LANGUAGE_KEY = "ecoverso-language";
